import React from 'react'
import "./AmpleProductionPage.css";
import HeroSection from './JourneyManPages/HeroSection'
import WelcomeSection from './JourneyManPages/WelcomeSection'
import PathwaySection from './JourneyManPages/PathwaySection'
import OurReasonSection from './JourneyManPages/OurReasonSection'



export default function AmpleProductionPage() {
  return (
      <div className="page-container">
        <HeroSection/>
        <WelcomeSection/>
        <PathwaySection/>
        <OurReasonSection/>
        
        
      </div>
  )
}

